import r from "../managers/braze-instance.js";
import ir from "./feature-flags-provider.js";
const tr = {
  l: !1,
  provider: null,
  m: () => (
    tr.p(),
    tr.provider ||
      ((tr.provider = new ir(r.v(), r.g(), r.j(), r.P())), r._(tr.provider)),
    tr.provider
  ),
  p: () => {
    tr.l || (r.h(tr), (tr.l = !0));
  },
  destroy: () => {
    (tr.provider = null), (tr.l = !1);
  },
};
export default tr;
